import abi from "./abis/ERC1155base.json";
import {
  getv,
  iso,
  nils,
  tofeth,
  tofpval,
  toeth,
  base64_to_json,
  blocktime_iso,
} from "../../utils/utils.jsx";
import { ethers } from "ethers";
import _ from "lodash";
import { CV2_Contract } from "./cv2_base.js";
import { contractAddress_list } from "../contracts.jsx";

const k = "erc1155_base";

// Multi-token contract address mapping - generated from contractAddress_list
const MULTI_TOKEN_ADDRESSES = {
  CORELOOTBOXV2: contractAddress_list.corelootboxv2,
  SKINLOOTBOXV1: contractAddress_list.skinlootboxv1,
  SKINLOOTBOXV2: contractAddress_list.skinlootboxv2,
  SKINLOOTBOXV3: contractAddress_list.skinlootboxv3,
  FACTIONSAGENTSBOX: contractAddress_list.factionsagentsbox,
  PRIZEBOX: contractAddress_list.prizebox,
  PRIZEBOX_OPENER: contractAddress_list.prizebox_opener,
};

class Contract extends CV2_Contract {
  constructor({ contract_k, contractAddress, aumode, abi, ...ext }) {
    super({ contract_k, contractAddress, aumode, abi, ...ext });
  }

  async getParsedLogs(logs) {
    if (!logs) return [];
    let logrows = [];
    for (let log of logs) {
      let iface = new ethers.Interface(this.abi);
      let par = iface.parseLog(log);
      if (nils(par)) continue;
      let name = par.name;
      let o = {
        name,
        logIndex: log.logIndex,
        hash: log.transactionHash,
        blockNumber: log.blockNumber,
      };
      o.id = `${o.hash}:${o.logIndex}`;
      logrows.push(o);
    }
    return logrows;
  }

  async balanceOf(account, id, info = {}) {
    let r = await this.run("balanceOf", [account, id], info);
    return r;
  }

  async balanceOfBatch(accounts, ids, info = {}) {
    let r = await this.run("balanceOfBatch", [accounts, ids], info);
    return r;
  }

  async setApprovalForAll(operator, approved, info = {}) {
    let tx = await this.run("setApprovalForAll", [operator, approved], info);
    return tx;
  }

  async isApprovedForAll(account, operator, info = {}) {
    let r = await this.run("isApprovedForAll", [account, operator], info);
    return r;
  }

  async safeTransferFrom(from, to, id, amount, data = "0x", info = {}) {
    let tx = await this.run(
      "safeTransferFrom",
      [from, to, id, amount, data],
      info,
    );
    return tx;
  }

  async safeBatchTransferFrom(from, to, ids, amounts, data = "0x", info = {}) {
    let tx = await this.run(
      "safeBatchTransferFrom",
      [from, to, ids, amounts, data],
      info,
    );
    return tx;
  }

  async uri(id, info = {}) {
    let r = await this.run("uri", [id], info);
    return r;
  }

  async supportsInterface(interfaceId, info = {}) {
    let r = await this.run("supportsInterface", [interfaceId], info);
    return r;
  }

  async totalSupply(id, info = {}) {
    let r = await this.run("totalSupply", [id], info);
    return r;
  }

  async exists(id, info = {}) {
    let r = await this.run("exists", [id], info);
    return r;
  }
}

const get_contract_address = (tokenSymbol) => {
  if (tokenSymbol.startsWith("0x")) return tokenSymbol;
  const address = MULTI_TOKEN_ADDRESSES[tokenSymbol.toUpperCase()];
  if (!address) {
    throw new Error(
      `Multi-token contract address not found for symbol: ${tokenSymbol}`,
    );
  }
  return address;
};

const get_contract = async (tokenSymbol, ext = {}) => {
  const contractAddress = get_contract_address(tokenSymbol);
  const runner = new Contract({
    contract_k: `erc1155_${tokenSymbol.toLowerCase()}`,
    contractAddress,
    aumode: ext.aumode || "thirdweb",
    abi,
    ...ext,
  });
  return runner;
};

// Helper function to add new multi-token contract addresses
const addMultiTokenAddress = (symbol, address) => {
  MULTI_TOKEN_ADDRESSES[symbol.toUpperCase()] = address;
};

// Helper function to get all supported multi-token contracts
const getSupportedMultiTokens = () => {
  return Object.keys(MULTI_TOKEN_ADDRESSES);
};

const ERC1155base = {
  k,
  get_contract,
  get_contract_address,
  addMultiTokenAddress,
  getSupportedMultiTokens,
  MULTI_TOKEN_ADDRESSES,
};

export default ERC1155base;
